import React, { useRef } from "react";


export type OnFileChosen = (file:File) => void


export function PickFileButton({onFileChosen, accept='.xlsx, .csv'}:{onFileChosen: OnFileChosen, accept?:string}){
    const ref = useRef<HTMLInputElement>();

    function onPick(){
        if(ref.current.files[0])
            onFileChosen(ref.current.files[0])
    }

    function pickFile(){
        ref.current.click();
    }

    return <>
        <input type="file" ref={ref} className="d-none" accept={accept} onChange={onPick} />
        <button className="btn btn-primary mt-4" onClick={pickFile}>Escolher Arquivo</button>
    </>
}